import { apiClient } from '../lib/api-client';
import type { LoginRequest, AdminUser } from '../types/admin-api';

export const authService = {
  login: async (credentials: LoginRequest) => {
    // Note: This uses the main API login endpoint
    // The Admin API doesn't have its own login - it uses the main API's /auth/login
    const response = await apiClient.post<{ token: string; user: any }>(
      '/auth/login',
      credentials
    );

    return response.data;
  },

  getCurrentAdmin: async () => {
    const response = await apiClient.get<AdminUser>('/admin/me');
    return response.data;
  },

  checkHealth: async () => {
    const response = await apiClient.get<{ status: string; authenticated: boolean }>(
      '/admin/health'
    );
    return response.data;
  },
};
